<template>
  <div v-if="itemKeys.length" class="card-category">
    <NuxtLink
      v-for="key in itemKeys"
      :key="key"
      :to="categories[key].button.url"
      class="card-category__item"
      :class="`card-category__item--${key}`"
    >
      <div class="card-category__title">{{ categories[key].title }}</div>
      <div class="card-category__btn">
        <atomic-icon id="back" />
      </div>
      <atomic-picture
        v-if="categories[key].image"
        class="card-category__picture" :src="categories[key].image" :alt="categories[key].title" />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { IHomePage } from "~/types";

type CategoryKey = keyof IHomePage['categories'];

const { categories } = defineProps<{
  categories: IHomePage['categories'];
}>();

const itemKeys = computed<CategoryKey[]>(() => {
  return categories ? Object.keys(categories) as CategoryKey[] : [];
});
</script>

<style src="~/assets/styles/components/card/category.scss" lang="scss" />
